import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import PinInputController from "./pin_input_controller"
application.register("pin-input", PinInputController)

import KeyRecoveryModalController from "./key_recovery_modal_controller"
application.register("key-recovery-modal", KeyRecoveryModalController)

import LoginTabController from "./login_tab_controller"
application.register("login-tab", LoginTabController)

import AccountCardController from "./account_card_controller"
application.register("account-card", AccountCardController)

import SlotDetailController from "./slot_detail_controller"
application.register("slot-detail", SlotDetailController)

import OauthLoginController from "./oauth_login_controller"
application.register("oauth-login", OauthLoginController)

import OauthPostmessageController from "./oauth_postmessage_controller"
application.register("oauth-postmessage", OauthPostmessageController)

import VaultController from "./vault_controller"
application.register("vault", VaultController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import OwnershipPinController from "./ownership_pin_controller"
application.register("ownership-pin", OwnershipPinController)

import SlotSelectorController from "./slot_selector_controller"
application.register("slot-selector", SlotSelectorController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import ListingFormController from "./listing_form_controller"
application.register("listing-form", ListingFormController)

import CommentController from "./comment_controller"
application.register("comment", CommentController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import CancelConfirmController from "./cancel_confirm_controller"
application.register("cancel-confirm", CancelConfirmController)

import ChatBadgeController from "./chat_badge_controller"
application.register("chat-badge", ChatBadgeController)

import AddressTruncateController from "./address_truncate_controller"
application.register("address-truncate", AddressTruncateController)

import BuyConfirmController from "./buy_confirm_controller"
application.register("buy-confirm", BuyConfirmController)

import NotConnectedModalController from "./not_connected_modal_controller"
application.register("not-connected-modal", NotConnectedModalController)
